// Updated CreateAbha.js with step persistence using localStorage
import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import CountUp from "react-countup";

import MobileVerify from "../Mobile-verify/mobile-verify";
import MobileOtp from "../Mobile-otp/mobile-otp";
import Patient from "../Patient/patient";
import ConfirmDetail from "../Confirm-detail/confirm-details";
import AdharNumber from "../Adhar-number/adhar-number";
import AdhaOtp from "../Adhar-otp/adhar-otp";
import AbhaAddress from "../Abha-address/abha-address";
import AbhaCard from "../Abha-card/abha-card";
import AadharCard from "../aadhar-card/aadhar-card";
import MobileVerifyOtp from "../Mobile-verify-otp/mobile-verify-otp";

import lab from "../../assets/image/lab.png";
import about from "../../assets/image/about_nha_pg_logo.png";
import benefits from "../../assets/image/benefits.png";
import benefits2 from "../../assets/image/benefits2.png";
import benefits3 from "../../assets/image/benefits3.png";
import benefits4 from "../../assets/image/benefits4.png";
import benefits5 from "../../assets/image/benefits5.png";
import benefits6 from "../../assets/image/benefits6.png";
import googleplay from "../../assets/image/google-play.png";
import appstore from "../../assets/image/app-stor.png";
import { setAbhaLoader } from "../../redux/slices/abhaSlice";
import { useSelector } from "react-redux";

const STEP_KEYS = [
  "mobile-verify",
  "mobile-otp",
  "patient",
  "confirm-detail",
  "adhar-number",
  "adhar-otp",
  "mobile-verify-otp",
  "aadhar-card",
  "abha-address",
  "done",
];

const CreatAbha = ({ onNavigate }) => {
  const [isVerified, setIsVerified] = useState(false);
  const [isVerifiedotp, setIsVerifiedOtp] = useState(false);
  const [isPatient, setPatient] = useState(false);
  const [isconfirm, setIsconfirm] = useState(false);
  const [isAdharNumber, setAdharNumber] = useState(false);
  const [isAdharOtp, setAdharOtp] = useState(false);
  const [isAdhaaddress, setAdhaaddress] = useState(false);
  const [isVerifiedMobileOTP, setMobileverifyOtp] = useState(false);
  const handleClick = () => {
    formRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  const { formRef } = useOutletContext();

  //   const { formRef } = useOutletContext();
  //   const [step, setStep] = useState(
  //     () => localStorage.getItem("step") || STEP_KEYS[0]
  //   );
  //   const [sendOtpFunction, setSendOtpFunction] = useState(null);
  //   const [adharNumbers, setAdharNumbers] = useState({});
  const loader = useSelector((state) => state.user.loading);

  //   useEffect(() => {
  //     localStorage.setItem("step", step);
  //   }, [step]);

  //   const handleClick = () => {
  //     formRef.current?.scrollIntoView({ behavior: "smooth" });
  //   };

  //   const goToNextStep = (next) => setStep(next);

  //  const goToPreviousStep = () => {
  //   const currentIndex = STEP_KEYS.indexOf(step);
  //   if (currentIndex > 0) {
  //     setStep(STEP_KEYS[currentIndex - 1]);
  //   }
  // };
  console.log("isVerified", isAdharNumber);

  return (
    <>
      {loader && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(255, 255, 255, 0.7)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            pointerEvents: "all",
          }}
        >
          {" "}
        </div>
      )}

      {!isVerified ? (
        <div ref={formRef}>
          <MobileVerify setIsVerified={setIsVerified} />
        </div>
      ) : (
        ""
      )}
      {isVerified && !isVerifiedotp && (
        <div ref={formRef}>
          <MobileOtp
            isVerified={isVerified}
            setIsVerifiedOtp={setIsVerifiedOtp}
          />
        </div>
      )}
      {isVerifiedotp && !isPatient && (
        <div ref={formRef}>
          <Patient isVerifiedotp={isVerifiedotp} setPatient={setPatient} />
        </div>
      )}
      {isPatient && !isconfirm && (
        <div ref={formRef}>
          <ConfirmDetail isPatient={isPatient} setIsconfirm={setIsconfirm} />
        </div>
      )}
      {isconfirm && !isAdharNumber && (
        <div ref={formRef}>
          <AdharNumber isconfirm={isconfirm} setAdharNumber={setAdharNumber} />
        </div>
      )}
      {isAdharNumber && !isAdharOtp && (
        <div ref={formRef}>
          <AdhaOtp isAdharNumber={isAdharNumber} setAdharOtp={setAdharOtp} />
        </div>
      )}
      {isAdharOtp && !isVerifiedMobileOTP && (
        <div ref={formRef}>
          <MobileVerifyOtp
            isAdharOtp={isAdharOtp}
            setMobileverifyOtp={setMobileverifyOtp}
          />
        </div>
      )}
      {isVerifiedMobileOTP && !isAdhaaddress && (
        <div ref={formRef}>
          <AbhaAddress
            isVerifiedMobileOTP={isVerifiedMobileOTP}
            setAdhaaddress={setAdhaaddress}
          />
        </div>
      )}
      {isAdhaaddress ? (
        <div ref={formRef}>
          <AbhaCard isAdhaaddress={isAdhaaddress} />
        </div>
      ) : (
        ""
      )}
      {/* {step === "mobile-verify" && (
        <div ref={formRef}>
          <MobileVerify setIsVerified={() => goToNextStep("mobile-otp")} />
        </div>
      )}
      {step === "mobile-otp" && (
        <div ref={formRef}>
          <MobileOtp setIsVerifiedOtp={() => goToNextStep("patient")} />
        </div>
      )}
      {step === "patient" && (
        <div ref={formRef}>
          <Patient setPatient={() => goToNextStep("confirm-detail")} />
        </div>
      )}
      {step === "confirm-detail" && (
        <div ref={formRef}>
          <ConfirmDetail setIsconfirm={() => goToNextStep("adhar-number")} />
        </div>
      )}
      {step === "adhar-number" && (
        <div ref={formRef}>
          <AdharNumber
            setAdharNumber={() => goToNextStep("adhar-otp")}
            setSendOtpFunction={setSendOtpFunction}
            setAdharNumbers={setAdharNumbers}
          />
        </div>
      )}
      {step === "adhar-otp" && (
        <div ref={formRef}>
          <AdhaOtp
            setAdharOtp={() => goToNextStep("mobile-verify-otp")}
            sendOtpFunction={sendOtpFunction}
          />
        </div>
      )}
      {step === "mobile-verify-otp" && (
        <div ref={formRef}>
          <MobileVerifyOtp
            setMobileverifyOtp={() => goToNextStep("aadhar-card")}
          />
        </div>
      )}
      {step === "aadhar-card" && (
        <div ref={formRef}>
          <AadharCard setAadharcart={() => goToNextStep("abha-address")} />
        </div>
      )}
      {step === "abha-address" && (
        <div ref={formRef}>
          <AbhaAddress setAdhaaddress={() => goToNextStep("done")} />
        </div>
      )}
      {step === "done" && (
        <div ref={formRef}>
          <AbhaCard setIsVerifiedMobile={() => goToNextStep("mobile-verify")} />
        </div> */}
      {/* )} */}

      {/* Stats Section */}
      <div className="banner-third-bg">
        <section className="container">
          {/* <div className="stats-section"> */}
          <div className="col-md-12">
            <div className="row">
              <div className="col-ms-3 col-lg-3">
                <div className="stats-item1">
                  <b>
                    <CountUp end={340} duration={5} separator="," />
                    M+
                  </b>
                  <p>ABHA Address Created</p>
                </div>
              </div>
              <div className="col-ms-3 col-lg-3">
                <div className="stats-item2">
                  <b>
                    <CountUp end={240} duration={5} separator="," />
                    M+
                  </b>
                  <p>ABHA Address Created</p>
                </div>
              </div>
              <div className="col-ms-3 col-lg-3">
                <div className="stats-item3">
                  <b>
                    <CountUp end={152} duration={5} separator="," />
                    K+
                  </b>
                  <p>ABHA Address Created</p>
                </div>
              </div>
              <div className="col-ms-3 col-lg-3">
                <div className="stats-item4">
                  <b>
                    <CountUp end={200} duration={5} separator="," />
                    K+
                  </b>
                  <p>Verified Facilities</p>
                </div>
              </div>
            </div>
          </div>
          {/* </div> */}
        </section>
      </div>

      {/* Info and Benefits Section */}
      <section className="banner-forth-bg abha-info-section">
        <div className="bg-color">
          <div className="row">
            <div className="col-ms-1 col-lg-1"></div>
            <div className="col-ms-5 col-lg-5">
              {/* <button onClick={goToPreviousStep}>Go Back</button> */}

              <div className="header-logos">
                <p>APPROVED BY NHA</p>
                <img src={about} alt="NHA Logo" className="nha-logo" />
                <img
                  src={lab}
                  alt="Pathkind Approved"
                  className="approved-logo approved-logo-nha"
                />
              </div>
              <div className="pathkind-lab">
                <h3>Create Pathkind Lab (Health ID)</h3>
              </div>
              <p className="abha-description">
                Be Part of Ayushman Bharat Digital Mission (ABDM) and Start Your
                <br /> Digital Health Journey
              </p>
              <button className="lik-abha-button" onClick={handleClick}>
                Create/Link Abha Address
              </button>
              <div className="app-links">
                <a
                  href="https://apps.apple.com/in/app/pathkind-labs/id6472930066"
                  target="_blank"
                >
                  <img src={appstore} alt="App Store" />
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.pathkind.app"
                  target="_blank"
                >
                  <img src={googleplay} alt="Google Play" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="abha-steps-section">
        <div className="container">
          <div className="heading-section">
            <h2>Benefits of ABHA HEALTH Card</h2>
            <p>
              Creating ABHA card is the first step towards making digital health
              records safer and more
              <br /> efficient for you and your family.
            </p>
          </div>

          <div className="row">
            {[
              benefits,
              benefits2,
              benefits3,
              benefits4,
              benefits5,
              benefits6,
            ].map((img, index) => (
              <div key={index} className="col-ms-6 col-lg-4">
                <div className="card-item">
                  <div className="benefit-item">
                    <div className="benefit-icons">
                      <img
                        src={img}
                        alt={`Benefit ${index + 1}`}
                        className="benefit-icon"
                      />
                      <h4>
                        {
                          [
                            "Digital Health Records",
                            "Personal Health Records (PHR)",
                            "Consent Based Access",
                            "Secure and Private",
                            "Voluntary Opt-In",
                            "Access to Doctors Digitally",
                          ][index]
                        }
                      </h4>
                    </div>
                  </div>
                  <p>
                    {
                      [
                        "All your health information at your fingertips.",
                        "Connect and integrate your individual health records using ABHA to build a comprehensive health history over time.",
                        "Your health data will only be accessed with your clear and informed consent.",
                        "Designed with robust security and encryption mechanisms, and no information is shared without your permission.",
                        "It is not mandatory to carry the ABHA Address card. If you wish to opt-out and request to erase your data at any time, you may do so",
                        "By registering for an ABHA Address, you will have access to doctors online securely and safely.",
                      ][index]
                    }
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default CreatAbha;
